export class SwaggerServer {
  public url: string;
}
